var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickleBallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2131_359)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 93.8485,
    cy: 89.8485,
    r: 87.3485,
    fill: "#6038FF",
    stroke: "#0C0F14",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.719 87.3249C168.477 126.636 136.177 159.246 95.4391 160.031C54.7008 160.816 21.1691 129.474 20.4117 90.1632C19.6542 50.852 51.9537 18.2422 92.6921 17.4573C133.43 16.6723 166.962 48.0138 167.719 87.3249Z",
    fill: "white",
    stroke: "#0C0F14",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3169 61.6427C88.4353 55.4946 91.6636 52.2565 93.5371 50.4782C95.1551 48.9423 95.914 48.3467 96.7631 47.8924C96.7635 47.8922 96.7639 47.892 96.7643 47.8918C96.9266 47.805 97.0922 47.7233 97.2677 47.6413L82.3169 61.6427ZM82.3169 61.6427L81.8652 61.1915M82.3169 61.6427L82.3166 61.643L81.8652 61.1915M98.0121 49.2311C97.8675 49.3004 97.7191 49.3741 97.5663 49.4527L97.5622 49.4548C97.5628 49.4544 97.5628 49.4545 97.562 49.4549C97.5504 49.4616 97.3848 49.5573 96.9231 49.9504C96.4488 50.3543 95.7605 50.9856 94.7176 51.9858C92.6373 53.9809 89.2735 57.3204 83.6339 62.9584L98.0121 49.2311ZM98.0121 49.2311L98.3289 49.9048C96.865 50.5889 96.4237 51.0112 83.8705 63.6257L98.0121 49.2311ZM81.8652 61.1915C72.8411 70.2247 68.3092 74.9123 67.868 75.6567L108.456 47.1083C106.13 45.9213 103.543 45.4586 100.936 45.7805C99.3917 45.9616 98.0682 46.384 96.4237 47.229C95.401 47.7521 93.1352 49.9248 81.8652 61.1915ZM53.0903 121.853C53.0863 121.847 53.0846 121.844 53.0848 121.844C53.0849 121.845 53.0869 121.847 53.0903 121.853Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.984 107.908C116.13 108.841 112.528 111.796 110.804 115.431C109.797 117.57 109.429 119.164 109.429 121.535C109.429 131.119 118.745 137.807 127.809 134.716C129.804 134.035 131.179 133.199 132.806 131.644C134.549 129.972 135.479 128.592 136.292 126.434C137.377 123.538 137.493 120.136 136.622 117.414C135.13 112.807 131.295 109.152 126.744 107.986C124.943 107.519 121.728 107.48 119.984 107.908ZM125.969 110.999C131.276 112.399 134.685 117.414 134.007 122.857C133.465 127.212 130.404 130.789 126.201 131.994C124.865 132.383 122.192 132.441 120.759 132.11C116.033 130.983 112.528 126.531 112.528 121.652C112.528 120.699 112.663 119.416 112.818 118.814C113.767 115.14 116.866 111.99 120.488 111.018C121.863 110.649 124.575 110.629 125.969 110.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.091 114.266C116.091 114.941 115.6 115.803 115.6 116.927C115.6 118.577 116.732 119.814 118.393 119.983C119.545 120.076 120.526 119.664 121.224 118.746C121.904 117.865 121.96 116.028 121.338 115.203C120.3 113.797 118.412 113.385 117.091 114.266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.576 114.051C126.261 114.201 125.761 114.616 125.483 114.994C124.037 116.918 125.242 119.728 127.614 119.973C128.745 120.086 129.486 119.784 130.209 118.955C131.544 117.389 131.21 115.182 129.486 114.201C128.671 113.73 127.447 113.673 126.576 114.051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 123.501C116.158 124.077 115.726 124.708 115.614 125.934C115.52 127.141 115.914 128.107 116.74 128.683C118.862 130.188 121.772 128.702 121.772 126.12C121.753 124.597 120.213 123.092 118.674 123.092C118.355 123.092 117.716 123.278 117.266 123.501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.489 123.497C124.583 124.516 124.287 127.111 125.916 128.501C128.839 130.966 132.707 127.092 130.246 124.164C129.283 123.034 127.859 122.774 126.489 123.497Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2131_359",
    x: 0,
    y: 0,
    width: 187.697,
    height: 187.697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2131_359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2131_359",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickleBallIcon);
export default __webpack_public_path__ + "static/media/PickleBallIcon.0a68f1b7ca46c2484dd7f1bfa0c6f24d.svg";
export { ForwardRef as ReactComponent };